module.exports = __webpack_public_path__ + "img/I2C_Fig12.b9962ca3.png";